import { Box, BoxProps, Button } from "@mui/material";
import { useLanguage } from "inspector-common/lib/language";

interface LoginButtonProps {
    onClick: () => void
};

const boxProps: BoxProps = {
    sx: {
        paddingLeft: "24px",
        paddingRight: "24px",
        paddingTop: "36px",
        paddingBottom: "36px"
    },
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
}

function LoginButton(props: LoginButtonProps) {
    const label = useLanguage().users.login;

    return <Box {...boxProps}>
        <Button variant="contained" fullWidth onClick={props.onClick}>{label}</Button>
    </Box>
};

export default LoginButton;